// extracted by mini-css-extract-plugin
module.exports = {"component":"Toolbar--component","group":"Toolbar--group","languageSelector":"Toolbar--languageSelector","saveButton":"Toolbar--saveButton"};